import { useEffect, useState } from "react";
import axios from "axios";
import config from "./config";

/**
 * Popup banner ad (onload). Shows after the configured delay, once per session.
 */
function BannerPopup({ token, groupToken, placement = "community_page" }) {
  const [banner, setBanner] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    let active = true;
    let timer;
    axios
      .post(`${config.COMMUNITY_API_URL}/community-banners`, {
        community_token: token,
        group_token: groupToken,
        placement,
      })
      .then((res) => {
        if (!active || res.data?.error !== 0) return;
        const popup = (res.data.popups || [])[0];
        if (!popup) return;
        if (sessionStorage.getItem(`banner_${token}_${popup.id}`)) return; // already dismissed
        timer = setTimeout(() => {
          if (active) {
            setBanner(popup);
            setShow(true);
          }
        }, (popup.delay || 0) * 1000);
      })
      .catch(() => {});
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [token, groupToken, placement]);

  const close = () => {
    if (banner) {
      try {
        sessionStorage.setItem(`banner_${token}_${banner.id}`, "1");
      } catch {
        /* ignore */
      }
    }
    setShow(false);
  };

  if (!show || !banner) return null;

  const img = (
    <img src={banner.image} alt="" className="w-full rounded-xl shadow-2xl block" />
  );

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={close}
    >
      <div className="relative max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={close}
          aria-label="Close"
          className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-white text-gray-700 shadow-lg flex items-center justify-center text-xl leading-none hover:bg-gray-100 z-10"
        >
          ×
        </button>
        {banner.link ? (
          <a href={banner.link} target="_blank" rel="noreferrer" onClick={close}>
            {img}
          </a>
        ) : (
          img
        )}
      </div>
    </div>
  );
}

export default BannerPopup;
